import { useContext, useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { StepValidationContext } from '../contexts/stepValidation';
import { showValidationError } from '../forms/utils';
import { useTranslation } from '../hooks';
export function useValidationError(validationSelector, validationEffects = [], i18n, i18nVariables, i18nPrefix) {
    const { t } = useTranslation();
    const stepValidation = useContext(StepValidationContext);
    const [lastValidation, setLastValidation] = useState(0);
    const validation = useRecoilValue(validationSelector);
    const [activeValidation, setActiveValidation] = useState(false);
    // on-mount (and on change of a validationEffect, e.g. disabled)
    // set the last validation to be the current stepValidation count
    useEffect(() => {
        setLastValidation(stepValidation);
        // TODO: Test and fix this without eslint disable
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, validationEffects);
    // if the step validation is higher than the last validation we set, validate
    const stepValidationActive = activeValidation || stepValidation > lastValidation;
    const invokeValidation = () => {
        setActiveValidation(true);
    };
    const helperText = showValidationError(t, validation, stepValidationActive, i18n, i18nVariables, i18nPrefix);
    return {
        validationError: helperText,
        stepValidationActive,
        invokeValidation,
    };
}
